export default __webpack_public_path__ + "static/media/orphans.ff218499.jpg";